import React from "react";

import { Modal, ModalBody, ModalFooter } from "reactstrap";

import TwoFASetupForm from "./TwoFASetupForm";

const TwoFASetupModal = ({ onClose, onSubmit, userId, defaultTwoFASetup }) => {
  return (
    <Modal isOpen={true} onClosed={onClose} size="sm">
      <ModalBody>
        <TwoFASetupForm
          onClose={onClose}
          onSubmit={onSubmit}
          userId={userId}
          defaultTwoFASetup={defaultTwoFASetup}
        />
      </ModalBody>
      <ModalFooter />
    </Modal>
  );
};

export default TwoFASetupModal;
